import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { EnumHelper, TransactionStatus, TransactionType, TransferMethod, TransferMethodLabel, TransferSource, TransferSourceLabel } from 'common';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'ifb-transaction-create-dialog',
    templateUrl: './transaction-create-dialog.component.html',
    styleUrls: ['./transaction-create-dialog.component.css'],
    standalone: false
})
export class TransactionCreateDialogComponent {

  status: string;
  type: string;
  transferMethod: string;
  transferSource: string;
  promotions: string;
  competitors: string;

  constructor(public dialogRef: MatDialogRef<TransactionCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.status = EnumHelper.getNameFromValue(TransactionStatus, this.data.form.value.status);
    this.type = EnumHelper.getNameFromValue(TransactionType, this.data.type);
    this.transferMethod = EnumHelper.getMappedNameFromValue(TransferMethod, TransferMethodLabel, this.data.form.value.transferMethod);
    this.transferSource = EnumHelper.getMappedNameFromValue(TransferSource, TransferSourceLabel, this.data.form.value.transferSource);
    this.promotions = this.data.promotions;
    this.competitors = this.data.competitors;
  }

  static show(dialog: MatDialog, form: UntypedFormGroup, type: TransactionType, amount: number, promotions?: string, competitors?: string): Observable<any> {
    return dialog.open(TransactionCreateDialogComponent, {
      width: '510px',
      data: {
        form: form,
        type: type,
        amount: amount,
        promotions: promotions,
        competitors
      },
      closeOnNavigation: true,
    }).afterClosed();
  }
}
